<pdf-shy-button
  title="Comment"
  primaryToolbarId="editorCommentButton"
  [cssClass]="show | responsiveCSSClass : 'hiddenTinyView'"
  l10nId="pdfjs-editor-comment-button"
  l10nLabel="pdfjs-editor-comment-button-label"
  role="radio"
  ariaHasPopup="true"
  ariaControls="editorCommentParamsToolbar"
  [order]="3900"
  [action]="onClick"
  [toggled]="isSelected"
  [closeOnClick]="false"
  image="<svg aria-hidden='true' focusable='false' width='20px' height='20px' viewBox='0 0 24 24'> <path fill='currentColor' d='M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10Z' /> </svg>"
>
</pdf-shy-button>